import React, { lazy, Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutAction } from './redux/actions/authActions';
import './App.css';
import TourProvider from './utils/TourProvider';
// Lazy-loaded components
const Dashboard = lazy(() => import('./components/Dashboard'));
const LoginSignup = lazy(() => import('./auth/Login-Signup'));
const UserSubscription = lazy(() => import('./components/UserSubscription'));
const OrganizationsList = lazy(() => import('./components/OrganizationsList'));
const ProfilePage = lazy(() => import('./components/ProfilePage'));
const AllOrganizationsForPortal = lazy(() => import('./components/AllOrganzationsForPortal'));
const UserList = lazy(() => import('./components/UserList'));
const AccessMatrix = lazy(() => import('./components/AccessMatrix'));
const DataDashboard = lazy(() => import('./components/DataDashboard'));
const DeviceDetails = lazy(() => import('./components/DeviceDetails'));
const BootupEvents = lazy(() => import('./components/BootupEvents'));
const Alert = lazy(() => import('./components/Alert'));
const Alluser = lazy(() => import('./components/Alluser'));
const Alldevice = lazy(() => import('./components/Alldevice'));
const Sites = lazy(() => import('./components/Sites'));
const Devicetype = lazy(() => import('./components/Devicetype'));
const Container = lazy(() => import('./components/Container'));
const Manufacturers = lazy(() => import('./components/Manufacturers'));
const DeviceSetting = lazy(() => import('./components/DeviceSetting'));
const MapView = lazy(() => import('./components/MapView'));
const Aboutus = lazy(() => import('./components/Aboutus'));
const Chatbot = lazy(() => import('./components/Chatbot'));
const FeedbackList = lazy(() => import('./components/FeedbackList'));
const Simulator = lazy(() => import('./components/Simulator'));
const WidgetDashboard = lazy(() => import('./components/WidgetDashboard'));
const MapDashboard = lazy(() => import('./components/Mapdashbord'));
const File = lazy(() => import('./components/File'));
const WaterLable = lazy(() => import('./components/WaterLable'));
const WaterOutletDevice = lazy(() => import('./components/WaterOutletDevice'));
const DriveAnalysis = lazy(() => import('./components/DriveAnalysis'));
const DeviceConfigForm = lazy(()=>import('./components/DeviceConfigForm'));

function App() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const logindashboard = sessionStorage.getItem('logindashboard');

  const handleLogout = () => {
    dispatch(logoutAction());
  };

  return (
    <>
      <ToastContainer  />

      <Router basename="/sensoto">
        <Suspense fallback={<div className="overlay">
          <div className="circular-loader">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>}>

          
          <Routes>
            {!isAuthenticated ? (
              // Unauthenticated routes
              <>
                <Route path="/login-signup" element={<LoginSignup />} />
                <Route path="*" element={<Navigate to="/login-signup" replace />} />
              </>
            ) : (
              // Authenticated routes
              <>
                <Route path="/user-subscription" element={<UserSubscription />} />
                <Route path="/organizations" element={<OrganizationsList />} />
                <Route path='device-details' element={<DeviceDetails />} />
                <Route path='bootup-list' element={<BootupEvents />} />
                <Route path='alert' element={<Alert />} />
                <Route path="users" element={<Alluser />} />
                <Route path="devices" element={<Alldevice />} />
                <Route path="sites" element={<Sites />} />
                <Route path="device-Types" element={<Devicetype />} />
                <Route path="containers" element={<Container />} />
                <Route path="manufacturers" element={<Manufacturers />} />
                <Route path="device-setting" element={<DeviceSetting />} />
                <Route path="map-view" element={<MapView />} />
                <Route path="help" element={<Aboutus />} />
                <Route path="chatbot" element={<Chatbot />} />
                <Route path="feedback" element={<FeedbackList />} />
                <Route path="simulator" element={<Simulator />} />
                <Route path="widget-dashboard" element={<WidgetDashboard />} />
                <Route path="file" element={<File />} />
                <Route path="water" element={<WaterLable />} />
                <Route path="wateroutlet" element={<WaterOutletDevice />} />
                <Route path="home" element={<MapDashboard />} />
                <Route path="drive-analysis" element={<DriveAnalysis />} />
                <Route path="device-config" element={<DeviceConfigForm />} />
                    
                {/* <Route path="insight-board" element={<Dashboard />} /> */}

                {logindashboard == 1 ? (
                  <>
                    {/* <Route path="/dashboard" element={<Dashboard onLogout={handleLogout} />} /> */}
                    {/* <Route path="/dashboard" element={<DataDashboard onLogout={handleLogout} />} /> */}
                    <Route path="/trip-insights" element={<Dashboard onLogout={handleLogout} />} />
                    <Route path="*" element={<Navigate to="/trip-insights" replace />} />
                    {/* <Route path="data-dashboard" element={<DataDashboard/>} /> */}
                  </>
                ) : (
                  <>
                    <Route path="*" element={<Navigate to="/profile-page" replace />} />
                    <Route path="profile-page" element={<ProfilePage to="/profile-page" replace />} />
                    <Route path="org" element={<AllOrganizationsForPortal />} />
                    <Route path="userList" element={<UserList />} />
                    <Route path="user-access-matrix" element={<AccessMatrix />} />

                  </>

                )}
              </>
            )}

          </Routes>
        
        </Suspense>

      </Router>

    </>
  );
}

export default App;
